import NamedDto from 'modules/base/dto/NamedDto';

export class WhatIfTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.creator = null;
		/** @type {NamedDto} */
		this.userGroup = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
		/** @type {NamedDto} */
		this.aspect = null;
		/** @type {NamedDto} */
		this.transformer = null;
	}

	/**
	 * @typedef {Object} _WhatIfTableDtoProps
	 * @property {NamedDto} creator
	 * @property {NamedDto} userGroup
	 * @property {Date} created
	 * @property {Date} updated
	 * @property {NamedDto} aspect
	 * @property {NamedDto} transformer
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _WhatIfTableDtoProps} WhatIfTableDtoProps
	 */
	/**
	 *
	 * @param {WhatIfTableDtoProps} props
	 * @returns {WhatIfTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.creator = props.creator !== null ? new NamedDto().setup(props.creator) : null;
		this.userGroup = props.userGroup !== null ? new NamedDto().setup(props.userGroup) : null;
		this.created = props.created != null ? new Date(props.created) : null;
		this.updated = props.updated != null ? new Date(props.updated) : null;
		this.aspect = props.aspect != null ? new NamedDto().setup(props.aspect) : null;
		this.transformer = props.transformer != null ? new NamedDto().setup(props.transformer) : null;
		return this;
	}
}

export default WhatIfTableDto;
